import Work1 from "../../assets/work/doctrs-web.jpg";
import Work2 from "../../assets/work/ecommerce.png";
import Work3 from "../../assets/work/homeSecurity-arduino.jpg";
import Work4 from "../../assets/work/food-delivery.png";
import Work5 from "../../assets/work/carRental-web.png";
import Work6 from "../../assets/work/school-management-arduino.png";

export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "Online Doctor Consultation",
      category: "Web",
    },
    {
      id: 2,
      image: Work2,
      title: "Ecommerce App",
      category: "App",
    },
    {
      id: 3,
      image: Work3,
      title: "Arduino Home Security",
      category: "IOT",
    },
    {
      id: 4,
      image: Work4,
      title: "Food Delivery App",
      category: "App",
    },
    {
      id: 5,
      image: Work5,
      title: "Car Rental",
      category: "Web",
    },
    {
      id: 6,
      image: Work6,
      title: "Student Activity Tracker",
      category: "IOT",
    },
];

export const projectsNav = [
  {
      name: 'All',
  },
  {
      name: 'Web',
  },
  {
      name: 'App',
  },
  {
      name: 'IOT',
  }
];

